import { TransportOutput, UpdateTripTransportInput } from '@allocab/allocab-commons-shared-types';
import { TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { TransportPickerStep1 } from './TransportPickerStep1';
import { TransportPickerStep2 } from './TransportPickerStep2';
import { useUpdateAnonymousTransport } from '../../../hooks/useUpdateAnonymousTransport';
import { useUpdateTransport } from '../../../hooks/useUpdateTransport';
import { queryKeys } from '../../../services/datastore/queryKeys';
import { queryClient } from '../../../services/datastore/react-query';
import { ToastManager } from '../../../services/toast/utils';
import { t } from '../../../services/translation/translation';
import { TransportPickerType } from '../../../services/types';
import { formatDateForParisTZ } from '../../../utils/date';
import { useIsShareRoute } from '../../../utils/navigation';
import { Modal } from '../../Modal';

type Props = {
  trip: TripOutput;
  type: TransportPickerType | null;
  onClose: () => void;
};

export const TransportPicker = ({ trip, type, onClose }: Props) => {
  const isShareRoute = useIsShareRoute();
  const { jwtToken } = useParams();

  const tripInfo = trip;
  const [transport, setTransport] = useState<TransportOutput | null>(null);

  const handleTransport = (transport: TransportOutput) => {
    setTransport(transport);
  };

  const onSuccess = (trip: TripOutput) => {
    ToastManager.show({
      message: t('transport-number-modal.success', {
        datetime: formatDateForParisTZ(trip.resume.departureAt, t('transport-number-modal.date-format')),
      }),
      severity: 'success',
      timer: 0,
    });
    if (isShareRoute) {
      queryClient.setQueryData(queryKeys.fetchAnonymousTrip(jwtToken), trip);
    } else queryClient.setQueryData(queryKeys.user.fetchTrip(trip.key), trip);
    onClose();
  };

  const { mutate: updateTransportShare, isLoading: isLoadingShare } = useUpdateAnonymousTransport(trip.key, jwtToken);
  const { mutate: updateTransport, isLoading: isLoading } = useUpdateTransport(trip.key);

  const handleUpdate = (input: UpdateTripTransportInput) => {
    if (isShareRoute) {
      updateTransportShare({ ...input }, { onSuccess });
    } else {
      updateTransport({ ...input }, { onSuccess });
    }
  };

  if (type == null) return null;

  return (
    <div>
      <Modal onClose={onClose}>
        {transport === null ? (
          <TransportPickerStep1 onValidate={handleTransport} type={type} trip={tripInfo} />
        ) : (
          <TransportPickerStep2
            onClose={onClose}
            onUpdate={handleUpdate}
            transport={transport}
            isLoading={isLoading || isLoadingShare}
            trip={trip}
          />
        )}
      </Modal>
    </div>
  );
};
